'use client';

import { createContext, PropsWithChildren, useContext } from 'react';
import { Span } from '@chakra-ui/react';
import type { ThemeProviderProps } from 'next-themes';
import { ThemeProvider } from 'next-themes';

export type ModeProviderProps = ThemeProviderProps;

export function ModeProvider(props: ModeProviderProps) {
  // eslint-disable-next-line i18next/no-literal-string -- not user facing text
  return <ThemeProvider attribute="class" disableTransitionOnChange {...props} />;
}

export const LEGACY_MODE = 'legacy';
export const MODERN_MODE = 'modern';

const LIGHT_THEME = 'light';
const DARK_THEME = 'dark';

// eslint-disable-next-line @oaknorth/ui/no-template-literals -- class not user facing text
export const LEGACY_THEME_CLASS = `chakra-theme ${LIGHT_THEME}`;
// eslint-disable-next-line @oaknorth/ui/no-template-literals -- class not user facing text
export const MODERN_THEME_CLASS = `chakra-theme ${DARK_THEME}`;
export type Mode = typeof LEGACY_MODE | typeof MODERN_MODE;

// export const MODE_CLASS: Record<Mode, string> = {
//   [LEGACY_MODE]: LEGACY_THEME_CLASS,
//   [MODERN_MODE]: MODERN_THEME_CLASS,
// };

// export interface UseModeReturn {
//   mode: Mode;
//   setMode: (colorMode: Mode) => void;
//   toggleMode: () => void;
// }

// export function useMode(): UseModeReturn {
//   const { resolvedTheme, setTheme, forcedTheme } = useTheme();
//   const colorMode = forcedTheme || resolvedTheme;
//   const toggleMode = () => {
//     setTheme(resolvedTheme === DARK_THEME ? LEGACY_MODE : MODERN_MODE);
//   };
//   return {
//     mode: colorMode as Mode,
//     setMode: (mode: Mode) => {
//       setTheme(mode === LEGACY_MODE ? LIGHT_THEME : DARK_THEME);
//     },
//     toggleMode,
//   };
// }

export function useModeValue<T>(v1: T, v2: T) {
  const { mode } = useMode();
  return mode === LEGACY_MODE ? v1 : v2;
}

// export const LegacyMode = forwardRef<HTMLSpanElement, SpanProps>(function V1Mode(props, ref) {
//   return (
//     <Span
//       color="fg"
//       display="contents"
//       className={LEGACY_THEME_CLASS}
//       colorPalette="blue"
//       colorScheme={LIGHT_THEME}
//       ref={ref}
//       {...props}
//     />
//   );
// });

// export const ModernMode = forwardRef<HTMLSpanElement, SpanProps>(function V2Mode(props, ref) {
//   return (
//     <Span
//       color="fg"
//       display="contents"
//       className={MODERN_THEME_CLASS}
//       colorPalette="blue"
//       colorScheme={DARK_THEME}
//       ref={ref}
//       {...props}
//     />
//   );
// });

interface ModeValue {
  mode: typeof LEGACY_MODE | typeof MODERN_MODE;
}

export const ModeContext = createContext<ModeValue | undefined>(undefined);

export function ModernMode({ children }: PropsWithChildren<{}>) {
  return (
    <ModeContext.Provider value={{ mode: MODERN_MODE }}>
      <Span color="fg" display="contents" className={MODERN_THEME_CLASS} colorPalette="blue" colorScheme={DARK_THEME}>
        {children}
      </Span>
    </ModeContext.Provider>
  );
}

export function LegacyMode({ children }: PropsWithChildren<{}>) {
  return (
    <ModeContext.Provider value={{ mode: LEGACY_MODE }}>
      <Span color="fg" display="contents" className={LEGACY_THEME_CLASS} colorPalette="blue" colorScheme={LIGHT_THEME}>
        {children}
      </Span>
    </ModeContext.Provider>
  );
}

export function useMode() {
  const context = useContext(ModeContext);
  if (!context) {
    throw Error('useMode must be used within a ModeProvider');
  }

  return context;
}
